import React, { Component } from "react";
import { Header, Table, Segment } from "semantic-ui-react";
import { apiUrl } from "../../utils/constants";

class HelpXml extends Component {
  render() {
    return (
      <Segment basic>
        <Header as="h3">
          <Header.Subheader>
            Your scoreboard XML feed is located here:
          </Header.Subheader>
          <a href={apiUrl() + "/feeds/dak"} target="_blank" rel="noopener noreferrer">
            {apiUrl() + "/feeds/dak"}
          </a>
        </Header>
        <p>
          This feed provides data for only the current active event. In most
          cases you will want to use one of the "pool" values below for display,
          though you may want to include one of the "prize" values as well if
          you have room to display both.
        </p>
        <Table striped>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell colSpan="2">
                Available XML Elements:
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            <Table.Row>
              <Table.Cell>timestamp</Table.Cell>
              <Table.Cell>The current Unix timestamp.</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>date_display</Table.Cell>
              <Table.Cell>The date of the event.</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>event</Table.Cell>
              <Table.Cell>The title of the event.</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>start</Table.Cell>
              <Table.Cell>The start time of the event.</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>end</Table.Cell>
              <Table.Cell>The end time of the event.</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>nonprofit_id</Table.Cell>
              <Table.Cell>
                The unique ID assigned to Non-profit.
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>pool</Table.Cell>
              <Table.Cell>
                The net jackpot as a raw, unformatted number.
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>pool_wd</Table.Cell>
              <Table.Cell>
                The net jackpot, with a dollar sign.
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>pool_nf</Table.Cell>
              <Table.Cell>
                The net jackpot, formatted to include thousand's separator.
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>pool_nf_wd</Table.Cell>
              <Table.Cell>
                The net jackpot, formatted to include thousand's separator
                with a dollar sign.
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>prize</Table.Cell>
              <Table.Cell>
                The prize as a raw, unformatted number (prize = net jackpot
                divided by 2).
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>prize_wd</Table.Cell>
              <Table.Cell>The prize, with a dollar sign.</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>prize_nf</Table.Cell>
              <Table.Cell>
                The prize, formatted to include thousand's separator.
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>prize_nf_wd</Table.Cell>
              <Table.Cell>
                The prize, formatted to include thousand's separator
                with a dollar sign.
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>prize_fl</Table.Cell>
              <Table.Cell>
                The prize, displayed in floating point format.
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>prize_fl_wd</Table.Cell>
              <Table.Cell>
              The prize, displayed in floating point format with a dollar sign.
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>prize_fl_nf</Table.Cell>
              <Table.Cell>
              The prize, displayed in floating point and formatted to include 
              thousand's separator.
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>prize_fl_nf_wd</Table.Cell>
              <Table.Cell>
              The prize, displayed in floating point and formatted to include 
              thousand's separator with a dollar sign.
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>winning_no</Table.Cell>
              <Table.Cell>
                The winning number. Note that this field will be blank until a
                winner has been selected.
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>reload</Table.Cell>
              <Table.Cell>
              Always 0, included for backwards compatibility.
              </Table.Cell>
            </Table.Row>
            <Table striped>
               <Table.Header>
               <Table.Row>
                 <Table.HeaderCell colSpan="2">
                   Addon Event Node Elements:
                 </Table.HeaderCell>
               </Table.Row>
             </Table.Header>
             <Table.Body>
             <Table.Row>
              <Table.Cell>timestamp</Table.Cell>
              <Table.Cell>The current Unix timestamp.</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>date_display</Table.Cell>
              <Table.Cell>The date of the addon event.</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>event</Table.Cell>
              <Table.Cell>The title of the addon event.</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>start</Table.Cell>
              <Table.Cell>The start time of the addon event.</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>end</Table.Cell>
              <Table.Cell>The end time of the addon event.</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>nonprofit_id</Table.Cell>
              <Table.Cell>
                The unique ID assigned to Non-profit.
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>pool</Table.Cell>
              <Table.Cell>
                The net jackpot as a raw, unformatted number.
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>pool_wd</Table.Cell>
              <Table.Cell>
                The net jackpot, with a dollar sign.
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>pool_nf</Table.Cell>
              <Table.Cell>
                The net jackpot, formatted to include thousand's separator.
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>pool_nf_wd</Table.Cell>
              <Table.Cell>
                The net jackpot, formatted to include thousand's separator
                with a dollar sign.
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>prize</Table.Cell>
              <Table.Cell>
                The prize as a raw, unformatted number (prize = net jackpot
                divided by 2).
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>prize_wd</Table.Cell>
              <Table.Cell>The prize, with a dollar sign.</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>prize_nf</Table.Cell>
              <Table.Cell>
                The prize, formatted to include thousand's separator.
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>prize_nf_wd</Table.Cell>
              <Table.Cell>
                The prize, formatted to include thousand's separator
                with a dollar sign.
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>prize_fl</Table.Cell>
              <Table.Cell>
                The prize, displayed in floating point format.
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>prize_fl_wd</Table.Cell>
              <Table.Cell>
              The prize, displayed in floating point format with a dollar sign.
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>prize_fl_nf</Table.Cell>
              <Table.Cell>
              The prize, displayed in floating point and formatted to include 
              thousand's separator.
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>prize_fl_nf_wd</Table.Cell>
              <Table.Cell>
              The prize, displayed in floating point and formatted to include 
              thousand's separator with a dollar sign.
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>winning_no</Table.Cell>
              <Table.Cell>
                The winning number. Note that this field will be blank until a
                winner has been selected.
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>reload</Table.Cell>
              <Table.Cell>
              Always 0, included for backwards compatibility.
              </Table.Cell>
            </Table.Row>
             </Table.Body>
            </Table>
            <Table striped>
               <Table.Header>
               <Table.Row>
                 <Table.HeaderCell colSpan="2">
                   Secondary Draw Node Elements:
                 </Table.HeaderCell>
               </Table.Row>
             </Table.Header>
             <Table.Body>
             <Table.Row>
              <Table.Cell>prize</Table.Cell>
              <Table.Cell>The prize as represented as text, provided by the user</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>winning_no</Table.Cell>
              <Table.Cell>The winning number. Note that this field will be blank until a
                winner has been selected.</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>draw_date</Table.Cell>
              <Table.Cell>The time that the secondary draw will occur</Table.Cell>
            </Table.Row>
             </Table.Body>
            </Table>
          </Table.Body>
        </Table>
        <br />
        <Header as="h4">Reference:</Header>
        <p>
          wd = With dollar sign.
          <br />
          nf = Number formatted with commas.
          <br />
          nf_wd = Number formatted with commas &amp; with dollar sign.
        </p>
      </Segment>
    );
  }
}

export default HelpXml;
